import { render } from "./UserEducations.vue?vue&type=template&id=7cf0dbb9"
import script from "./UserEducations.vue?vue&type=script&lang=js"
export * from "./UserEducations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__